import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const MenstrualCycle = lazyWithPreload(() => import('./MenstrualCycle'))
